import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {FormatterComponent} from "../../json-formatter/json-formatter.component";
import {IFailedAutoplayStripsRow} from "../../../interfaces/player/IFailedAutoplayStripsRow";

@Component({
  selector: 'app-failed-autoplay-details',
  templateUrl: './failed-autoplay-details.component.html',
  standalone: true,
  imports: [
    DialogBaseComponent,
    FormatterComponent
  ],
  styleUrls: ['./failed-autoplay-details.component.scss']
})
export class FailedAutoplayDetailsComponent {

  public metaData: any;
  public errorMessages: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    strip: IFailedAutoplayStripsRow,
    autoplayFailureDetails: string
  }) {
    // Parse the JSON string from AutoplayFailureDetails
    try {
      this.metaData = JSON.parse(this.data.autoplayFailureDetails);
      // Extract error messages from Result.Errors if available
      if (this.metaData?.Result?.Errors && Array.isArray(this.metaData.Result.Errors)) {
        this.errorMessages = this.metaData.Result.Errors;
      }
    } catch (e) {
      // If it's not valid JSON, just use the raw string
      this.metaData = this.data.autoplayFailureDetails;
    }
  }
}
